import React, { Component } from "react";
import { userDetail } from "../../config/userDetails";
import HelpForBasic from "../private/HelpForBasic";
import HelpForPaid from "../private/HelpForPaid";

class ShowHelpText extends Component {
    constructor(props) {
        super(props);
        this.state = {
          planId: userDetail().planId
        };
      }
    render() {
        const {planId} = this.state
        return(
            <div  className="print">
                {planId === 1 ? <HelpForBasic /> : <HelpForPaid/>}
            </div>
        )
    }
}

export default ShowHelpText


// WEBPACK FOOTER //
// ./src/components/private/ShowHelpText.js